
import Index from './index.vue'
import icon from '@/libs/src/assets/default.png';

export default (Application) => {

    let vce = Application.proc.make('VueCustomElement')
    let auth = Application.proc.make('Auth')
    vce.createApp({
        name: "operation-platform",
        alias: "运维管理",
        category: "运维工具",
        singleton: false,
        showTitle: false,
        // before:function(){
            
        //     if(!auth.isAdmin()){
        //         alert('无权限')
        //         return false;
        //     }
        //     return true;
        // },
        icon
    }, Index)

}